import script from "./SetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPassword.vue?vue&type=script&setup=true&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=54beb9a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54beb9a8"]])

export default __exports__